export var getIds = id => id ? {
  box: "".concat(id, "__box"),
  checkmark: "".concat(id, "__checkmark"),
  checkmarkWrapper: "".concat(id, "__checkmark-wrapper"),
  description: "".concat(id, "__description"),
  input: "".concat(id, "__input"),
  label: "".concat(id, "__label"),
  minus: "".concat(id, "__minus"),
  minusWrapper: "".concat(id, "__minus-wrapper"),
  overlay: "".concat(id, "__overlay"),
  root: "".concat(id, "__root"),
  text: "".concat(id, "__text"),
  title: "".concat(id, "__title")
} : undefined;
//# sourceMappingURL=getIds.js.map